"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.structureTestCells = exports.enrichEventsWithAdobeData = exports.addAdobeData = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _uuid = _interopRequireDefault(require("../utils/uuid"));

var _adobe = require("../utils/adobe");

var _constants = require("../constants");

var _urls = require("../utils/urls");

var _windowDimensions = require("../utils/windowDimensions");

var _cookies = require("../services/cookies");

var _misc = require("../utils/misc");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// The acquisition of the Adobe data is asynchronous, so we save adding it till the last moment,
// to allow caching of events
var addAdobeData = function addAdobeData(payload, _ref) {
  var mcid = _ref.mcid;

  var newClientCommon = _objectSpread(_objectSpread({}, payload.extensions.client_common), {}, {
    adobe_mcid: mcid
  });

  return _objectSpread(_objectSpread({}, payload), {}, {
    extensions: {
      client_common: newClientCommon
    }
  });
};

exports.addAdobeData = addAdobeData;

var enrichEventsWithAdobeData = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(events) {
    var adobeIds;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _adobe.getAdobeData)();

          case 2:
            adobeIds = _context.sent;
            return _context.abrupt("return", events.map(function (payload) {
              return addAdobeData(payload, adobeIds);
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function enrichEventsWithAdobeData(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.enrichEventsWithAdobeData = enrichEventsWithAdobeData;

var structureTestCells = function structureTestCells(testCells) {
  var structureTestCells; // If incoming test cells are in a hash map, convert to array:

  if (!Array.isArray(testCells) && (0, _typeof2["default"])(testCells) === 'object') {
    structureTestCells = Object.entries(testCells).reduce(function (testCellArray, _ref3) {
      var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
          layer = _ref4[0],
          cell = _ref4[1];

      testCellArray.push({
        layer: layer,
        cell: cell
      });
      return testCellArray;
    }, []);
  } else {
    structureTestCells = testCells;
  }

  return structureTestCells;
};

exports.structureTestCells = structureTestCells;

var structureData = function structureData(client, eventSpecs) {
  // Gather data from state
  var type = eventSpecs.type,
      data = eventSpecs.data,
      eventTime = eventSpecs.eventTime,
      eventTypeVersion = eventSpecs.eventVersion,
      _eventSpecs$options = eventSpecs.options,
      options = _eventSpecs$options === void 0 ? {} : _eventSpecs$options;
  var sessionStateOverrides = options.sessionStateOverrides || {};

  var state = _objectSpread(_objectSpread({}, client.stateManager.get()), sessionStateOverrides);

  var analyticsAgent = state.analyticsAgent,
      appId = state.appId,
      appVer = state.appVer,
      cheggUuid = state.cheggUuid,
      authState = state.authState,
      clientIpAddress = state.clientIpAddress,
      clientExperiments = state.clientExperiments,
      experiments = state.experiments,
      subscriptions = state.subscriptions,
      testCells = state.testCells,
      rswVersion = state.rswVersion,
      userAgent = state.userAgent,
      browserName = state.browserName,
      browserVersion = state.browserVersion,
      osName = state.osName,
      osVersion = state.osVersion,
      platform = state.platform,
      property = state.property,
      urlFromState = state.url,
      referrerFromState = state.referralUrl,
      uvn = state.uvn,
      view = state.view,
      viewPrevious = state.viewPrevious,
      dfid = state.dfid,
      alternateUserId = state.alternateUserId,
      alternateUserIdLabel = state.alternateUserIdLabel; // Convert test cells to proper format.

  var structuredTestCells = structureTestCells(testCells); // Prefer URLs from the browser, but use those from state if no window is present:

  var url = (0, _urls.getCurrentUrl)(urlFromState);
  var referrer = (0, _urls.getCurrentReferrer)(referrerFromState);
  var userSubscriptionStatus;

  if (subscriptions) {
    userSubscriptionStatus = subscriptions;
  } else {
    userSubscriptionStatus = [];
  }

  var clientCommon = {
    url: url,
    platform: platform,
    analytics_agent: analyticsAgent,
    user_agent: userAgent,
    chegg_uuid: cheggUuid,
    auth_state: authState,
    client_ip_address: clientIpAddress,
    test_cells: structuredTestCells,
    client_experiments: clientExperiments,
    experiments: experiments,
    referral_url: referrer,
    app_ver: appVer,
    browser_name: browserName,
    browser_version: browserVersion,
    os: osName,
    os_ver: osVersion,
    analytics_module_version: rswVersion,
    user_subscription_status: userSubscriptionStatus,
    base_event_type: _constants.BASE_EVENT_TYPE,
    base_event_version: _constants.BASE_EVENT_VERSION,
    uvn: uvn,
    view: view,
    view_previous: viewPrevious,
    dfid: dfid,
    window_dimensions: (0, _windowDimensions.getWindowDimensions)(),
    alternate_user_id: alternateUserId,
    browser_language: (0, _misc.getBrowserLanguage)(),
    session_replay_link: (0, _misc.getCsReplayLink)(),
    alternate_user_id_label: alternateUserIdLabel,
    client_cookie_consent: (0, _misc.getClientCookieConsent)(),
    browser_tracking: (0, _misc.getNavigatorDoNotTrack)(),
    global_privacy_control: (0, _misc.getNavigatorGPC)()
  };
  var enrichedClientCommon = (0, _cookies.enrichSessionWithCookies)(clientCommon);
  var topLevelDomain = (0, _urls.getTopLevelDomain)(url);
  var eventDataWithCachedData = data;

  if (client.eventContentCache.shouldEnrichEventWithCachedContent(eventSpecs)) {
    eventDataWithCachedData = client.eventContentCache.enrichEventData(data);
  } // Create the event:


  var event = {
    data: eventDataWithCachedData,
    event_id: _uuid["default"].get(),
    event_time: eventTime.toISOString(),
    cloud_events_version: '0.1',
    event_type: "".concat(topLevelDomain, ".").concat(property, ".").concat(type),
    source: "/".concat(_constants.BASE_EVENT_TYPE, "/").concat(property, "/").concat(appId),
    event_type_version: eventTypeVersion && eventTypeVersion.toString(),
    perimeterx_score: (0, _misc.getPerimeterxScore)(),
    content_type: 'application/json',
    extensions: {
      client_common: enrichedClientCommon
    }
  };
  return event;
};

var _default = structureData;
exports["default"] = _default;